export function formatDateTime(isoDateTime: Date): string {
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "short",
    timeStyle: "short",
  }).format(isoDateTime);
}

export function formatDateTimeString(isoDateTimeString: string): string {
  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "short",
    timeStyle: "short",
  }).format(new Date(isoDateTimeString));
}
